import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Be3Repository} from '@app/@core/repositories/be3/be3-repository';
import {Observable} from 'rxjs';
import {EventLog, EventLogType, IEvent} from '@app/models/v3/event-log';

@Injectable({
    providedIn: 'root'
})
export class EventLogRepository extends Be3Repository<EventLog> {

    constructor(http: HttpClient) {
        super(http, 'event-log');
    }

    search(type: EventLogType, key: string): Observable<IEvent[]> {
        const params = {
            type,
            key
        };
        return this.http.get<IEvent[]>(`${this.entityUrl}/search/`, {params});
    }
}


